module.exports = __webpack_public_path__ + "6c3f6814876878623e87f8d04cec8411.svg";